import { Link } from "react-router-dom";
import { EmptyState } from "../components/ui/EmptyState";
import { Button } from "../components/ui/Button";
import { common } from "../copy/sq";

export function NotFoundScreen() {
  return (
    <EmptyState
      title={common.pageNotFoundTitle}
      description={common.pageNotFoundDescription}
      action={
        <Link to="/">
          <Button variant="primary">{common.backToToday}</Button>
        </Link>
      }
    />
  );
}
